import React, { useEffect, useState, Suspense } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import * as EnvConstants from "../src/Constants/EnvConstants";
import { VisitorParamsProvider } from "./Contexts/VisitorParams";
import HomePage from "./Components/Pages/HomePage";
import { RedirectProvider } from "./Contexts/RedirectContext";
import "./App.scss";
import AdtopiaLoadDynamic from "./Utility/AdtopiaLoadDynamic";

import EnvDocView from "./Components/Pages/LUFP_V1/EnvDocView";
import HelmetBasedOnDomain from "./Components/Includes/Layouts/Common/HelmetBasedOnDomain";
import { renderRoute } from "./Utility/LProutes";
import { RoutingConfig } from "./Utility/RoutingConfig";


// const LUFP_V1 = React.lazy(() => import("./Components/Pages/Splits/LUFP_V1"));
const LufpV1PersonalDetails = React.lazy(() => import("./Components/Pages/LUFP_V1/LufpV1PersonalDetails"));
const LufpV1Signature = React.lazy(() => import("./Components/Pages/LUFP_V1/LufpV1Signature"));
const LufpV1IdUpload = React.lazy(() => import("./Components/Pages/LUFP_V1/LufpV1IdUpload"));
// const LufpV1CarRegistration = React.lazy(() => import("./Components/Pages/LUFP_V1/LufpV1CarRegistration"));
const LufpV1Lenders = React.lazy(() => import("./Components/Pages/LUFP_V1/LufpV1Lenders"));
const FbPixel = React.lazy(() => import("./Components/Pages/FbPixel"));
const LufpV1Thankyou = React.lazy(() => import("./Components/Pages/LUFP_V1/LufpV1Thankyou"));
const ThankyouV2 = React.lazy(() => import("./Components/Includes/Layouts/Thankyou/ThankyouV2"));
const LufpV1CreditAnalysis = React.lazy(() => import("./Components/Pages/LUFP_V1/LufpV1CreditAnalysis"));
// const LUFP_V1B = React.lazy(() => import("./Components/Pages/Splits/LUFP_V1B"));
// const LUFP_TB_V1D = React.lazy(() => import("./Components/Pages/Splits/LUFP_TB_V1D"));
// const LUFP_V5 = React.lazy(() => import("./Components/Pages/Splits/LUFP_V5"));
// const LUFP_V5A = React.lazy(() => import("./Components/Pages/Splits/LUFP_V5A"));
// const LUFP_V5_5 = React.lazy(() => import("./Components/Pages/Splits/LUFP_V5_5"));
// const LUFP_V5_5A = React.lazy(() => import("./Components/Pages/Splits/LUFP_V5_5A"));
// const LUFP_V5_5B = React.lazy(() => import("./Components/Pages/Splits/LUFP_V5_5B"));
// const LUFP_V5N1 = React.lazy(() => import("./Components/Pages/Splits/LUFP_V5N1"));
// const LUFP_V5N1_1 = React.lazy(() => import("./Components/Pages/Splits/LUFP_V5N1_1"));
// const LUFP_V5N2 = React.lazy(() => import("./Components/Pages/Splits/LUFP_V5N2"));
const LUFPV1BPersonalDetails = React.lazy(() => import("./Components/Pages/LUFP_V1B/LUFPV1BPersonalDetails"));
const LUFPV1BSignature = React.lazy(() => import("./Components/Pages/LUFP_V1B/LUFPV1BSignature"));
const LUFPV1BCreditAnalysis = React.lazy(() => import("./Components/Pages/LUFP_V1B/LUFPV1BCreditAnalysis"));
const Loader = React.lazy(() => import("./Components/Includes/Layouts/Loader/Loader"))
const FollowUp = React.lazy(() => import("./Components/Pages/Followup/FollowUp"));
const FollowupSignature = React.lazy(() => import("./Components/Pages/Followup/FollowupSignature"));
const FollowupIdUplod = React.lazy(() => import("./Components/Pages/Followup/FollowupIdUpload"));
const FollowupLenders = React.lazy(() => import("./Components/Pages/Followup/FollwupLenders"));
// const FollowupCarRegistration = React.lazy(() => import("./Components/Pages/Followup/FollowupCarRegistration"));
const FollowupCreditAnalysis = React.lazy(() => import("./Components/Pages/Followup/FollowupCreditAnalysis"));
const FollowupLoader = React.lazy(() => import("./Components/Pages/Followup/FollowupLoader"))
const ADV_LUFP_1 = React.lazy(() => import("./Components/Pages/ADV_Page/ADV_LUFP_1"))
const ADV_LUFP_2 = React.lazy(() => import("./Components/Pages/ADV_Page/ADV_LUFP_2"))
// const LUFP_OBV1C = React.lazy(() => import("./Components/Pages/Splits/LUFP_OBV1C"));
// const LUFP_V1B_2 = React.lazy(() => import("./Components/Pages/Splits/LUFP_V1B_2"));
// const LUFP_V1B_1 = React.lazy(() => import("./Components/Pages/Splits/LUFP_V1B_1"));
const LUFPV1B1PersonalDetails = React.lazy(() => import("./Components/Pages/LUFP_V1B_1/LUFPV1B1PersonalDetails"));
const LUFPV1B1Signature = React.lazy(() => import("./Components/Pages/LUFP_V1B_1/LUFPV1B1Signature"));
const LUFPV1B1CreditAnalysis = React.lazy(() => import('./Components/Pages/LUFP_V1B_1/LUFPV1B1CreditAnalysis'));
// const LUFP_V1C = React.lazy(() => import("./Components/Pages/Splits/LUFP_V1C"));
const LufpV1CLenders = React.lazy(() => import("./Components/Pages/LUFP_V1C/LufpV1CLenders"));
const LufpV1cCreditcheckLenders = React.lazy(() => import("./Components/Pages/LUFP_V1B/LufpV1cCreditcheckLenders"));
const EditDetails = React.lazy(() => import("./Components/Pages/EditDetails"));
const CreditCheckEdit = React.lazy(() => import("./Components/Pages/CreditCheckEdit"));
const FollowupEditDetails = React.lazy(() => import("./Components/Pages/Followup/FollowupEditDetails"));
const FollowupCreditCheckEdit = React.lazy(() => import("./Components/Pages/Followup/FollowupCreditCheckEdit"));
const FollowupMultiCreditCheckEdit = React.lazy(() => import("./Components/Pages/Followup/FollowupMultiCreditCheckEdit"));
const scheduledMaintenance = React.lazy(() => import("./Components/Pages/scheduledMaintenance"));
// const LUFP_SVY_V2 = React.lazy(() => import("./Components/Pages/Splits/LUFP_SVY_V2"));
const LoaderSavvy = React.lazy(() => import("./Components/Includes/Layouts/Loader/LoaderSavvy"));

const HSLLoad = React.lazy(() => import("./Components/Includes/Layouts/Loader/HSLLoad"));
const LUFP_V1B2 = React.lazy(() => import("./Components/Pages/Splits/LUFP_V1B2"));
const QuestionnaireSection = React.lazy(() => import("./Components/Pages/Questionnaire/QuestionnaireSection"));
const FollwupQuestionnaireSection = React.lazy(() => import("./Components/Pages/Followup/FollwupQuestionnaireSection"));
const Dashboard = React.lazy(() => import("./Components/Pages/Dashboard/Dashboard"));
const CancellationForm = React.lazy(() => import("./Components/Includes/Layouts/Common/CancellationForm"));
const DashboardHSL = React.lazy(() => import("./Components/Pages/Dashboard/DashboardHSL"));
const DashboardRS = React.lazy(() => import("./Components/Pages/DashboardRS/DashboardRS"));
const DashboardHSLRS = React.lazy(() => import("./Components/Pages/DashboardRS/DashboardHSLRS"));
// const LUFP_V6 = React.lazy(() => import("./Components/Pages/Splits/LUFP_V6"));
const NotFound = React.lazy(() => import("./Components/Pages/NotFound"));
const ADV_PCP_V1 = React.lazy(() => import("./Components/Pages/ADV_Page/ADV_PCP_V1"));
const LUFPV5BSignature = React.lazy(() => import("./Components/Pages/LUFP_V5A/LUFPV5BSignature"));
const LUFP_V5N1_1Signature = React.lazy(() => import("./Components/Pages/LUFP_V5N1_1/LUFP_V5N1_1Signature"));
// const LUFP_V5N1_1B = React.lazy(() => import("./Components/Pages/Splits/LUFP_V5N1_1B"));
const LUFP_V5N1_1BSignature = React.lazy(() => import("./Components/Pages/LUFP_V5N1_1/LUFP_V5N1_1BSignature"));
// const LUFP_V5N1_1A = React.lazy(() => import("./Components/Pages/Splits/LUFP_V5N1_1A"));
const LUFP_V5N1_1ASignature = React.lazy(() => import("./Components/Pages/LUFP_V5N1_1/LUFP_V5N1_1ASignature"));
const LUFP_V5N1_1CSignature = React.lazy(() => import("./Components/Pages/LUFP_V5N1_1/LUFP_V5N1_1CSignature"));
const LUFP_V5N1_1B2Signature = React.lazy(() => import("./Components/Pages/LUFP_V5N1_1/LUFP_V5N1_1B2Signature"));
const LUFP_V7ASignature = React.lazy(() => import("./Components/Pages/LUFP_V5N1_1/LUFP_V7ASignature"));

const HslFollowUp = React.lazy(() => import("./Components/Pages/HslFollowup/HslFollowUp"));
const HslFollowupSignature = React.lazy(() => import("./Components/Pages/HslFollowup/HslFollowupSignature"));
const HslFollowupIdUpload = React.lazy(() => import("./Components/Pages/HslFollowup/HslFollowupIdUpload"))
const HslFollwupLenders = React.lazy(() => import("./Components/Pages/HslFollowup/HslFollwupLenders"));
// const HslFollowupCarRegistration = React.lazy(() => import("./Components/Pages/HslFollowup/HslFollowupCarRegistration"));
const HslFollowupCreditAnalysis = React.lazy(() => import("./Components/Pages/HslFollowup/HslFollowupCreditAnalysis"));
const HslFollowupLoader = React.lazy(() => import("./Components/Pages/HslFollowup/HslFollowupLoader"));
const HslFollwupQuestionnaireSection = React.lazy(() => import("./Components/Pages/HslFollowup/HslFollwupQuestionnaireSection"));
const LUFP_V5N1_2ASignature = React.lazy(() => import("./Components/Pages/LUFP_V5N1_2A/LUFP_V5N1_2ASignature"));

const LUFPV8APersonalDetails = React.lazy(() => import("./Components/Pages/LUFP_V8A/LUFPV8APersonalDetails"));
const LUFPV8ACreditAnalysis = React.lazy(() => import("./Components/Pages/LUFP_V8A/LUFPV8ACreditAnalysis"));
const LUFPV8ALenders = React.lazy(() => import("./Components/Pages/LUFP_V8A/LUFPV8ALenders"));
const LUFPV8BPersonalDetails = React.lazy(() => import("./Components/Pages/LUFP_V8B/LUFPV8BPersonalDetails"));
const LUFPV9PersonalDetails = React.lazy(() => import("./Components/Pages/LUFP_V5N1_V9/LUFPV9PersonalDetails"));
const LUFPV9ASignature = React.lazy(() => import("./Components/Pages/LUFP_V5N1_V9/LUFPV9ASignature"));
const LufpV10PersonalDetails = React.lazy(() => import("./Components/Pages/LUFP_V10/LufpV10PersonalDetails"));
const LUFPV10Signature = React.lazy(() => import("./Components/Pages/LUFP_V10/LUFPV10Signature"));
const LufpV10CreditAnalysis = React.lazy(() => import("./Components/Pages/LUFP_V10/LufpV10CreditAnalysis"));
const LUFPV10Lenders = React.lazy(() => import("./Components/Pages/LUFP_V10/LUFPV10Lenders"));
const LufpV10IdUpload = React.lazy(() => import("./Components/Pages/LUFP_V10/LufpV10IdUpload"));
const LufpV10Success = React.lazy(() => import("./Components/Pages/LUFP_V10/LufpV10Success"));
const CreditCheckEditV10 = React.lazy(() => import("./Components/Pages/CreditCheckEditV10"));
const AddressVerification = React.lazy(() => import("./Components/Pages/Checkboard/AddressVerification"));
const AMLCheck = React.lazy(() => import("./Components/Pages/Checkboard/AMLCheck"));
const CreditAnalysisCB = React.lazy(() => import("./Components/Pages/Checkboard/CreditAnalysisCB"));
const CBEditDetails = React.lazy(() => import("./Components/Pages/Checkboard/EditPage/CBEditDetails"));
const Otp = React.lazy(() => import("./Components/Pages/Checkboard/Otp"));
const CBLenders = React.lazy(() => import("./Components/Pages/Checkboard/CBLenders"));

const FollowupAddressVerification = React.lazy(() => import("./Components/Pages/Followup/Checkboard/FollowupAddressVerification"));
const FollowupAMLCheck = React.lazy(() => import("./Components/Pages/Followup/Checkboard/FollowupAMLCheck"));
const FollowupCreditAnalysisCB = React.lazy(() => import("./Components/Pages/Followup/Checkboard/FollowupCreditAnalysisCB"));
const FollowupOtp = React.lazy(() => import("./Components/Pages/Followup/Checkboard/FollowupOtp"));
const FollowupOtpV1 = React.lazy(() => import("./Components/Pages/Followup/FollowupOtpV1"));
const FollowupCBLenders = React.lazy(() => import("./Components/Pages/Followup/Checkboard/FollowupCBLenders"));
const FollowupCBEditDetails = React.lazy(() => import("./Components/Pages/Followup/Checkboard/EditPage/FollowupCBEditDetails"));
// const LUFPRJV1PersonalDetails = React.lazy(() => import("./Components/Pages/LUFP_RJ_V1/RjV1PersonalDetails"));
const RjSignature = React.lazy(() => import("./Components/Pages/LUFP_RJ_V1/RjSignature"));
const RjV1CreditAnalysis = React.lazy(() => import("./Components/Pages/LUFP_RJ_V1/RjV1CreditAnalysis"));
const RjV1Lenders = React.lazy(() => import("./Components/Pages/LUFP_RJ_V1/RjV1Lenders"));

const RjV1IdUpload = React.lazy(() => import("./Components/Pages/LUFP_RJ_V1/RjIdUpload"));
const RjV1Success = React.lazy(() => import("./Components/Pages/LUFP_RJ_V1/RjV1Success"));
const RjEditDetails = React.lazy(() => import("./Components/Pages/RjEditDetails"));
const RjCreditCheckEdit = React.lazy(() => import("./Components/Pages/RjCreditCheckEdit"));
const Terms = React.lazy(() => import("./Components/Pages/terms"));
const PrivacyPolicy = React.lazy(() => import("./Components/Pages/PrivacyPolicy"));
const Loader_MCFC_V5 = React.lazy(()=> import("./Components/Pages/MCFC_V5/Loader_MCFC_V5"));
const Lenders_MCFC_V5 = React.lazy(()=> import("./Components/Pages/MCFC_V5/Lenders_MCFC_V5"));
const Idupload_MCFC_V5 = React.lazy(()=> import("./Components/Pages/MCFC_V5/Idupload_MCFC_V5"));
const Success_MCFC_V5 = React.lazy(()=> import("./Components/Pages/MCFC_V5/Success_MCFC_V5"));
const Unsubscribe = React.lazy(() => import("./Components/Pages/Unsubscribe"));
const CreditCheckEdit_MCFC_V5 = React.lazy(() => import("./Components/Pages/MCFC_V5/CreditCheckEdit_MCFC_V5"));
const EditPage_MCFC_V5 = React.lazy(() => import("./Components/Pages/MCFC_V5/editpage/EditPage_MCFC_V5"));

// MCFC OL V6
const MCFCOLV6_PersonalDetails = React.lazy(() => import("./Components/Pages/MCFC_OL_V6/Pages/PersonalDetails"));
const MCFCOLV6_Signature = React.lazy(() => import("./Components/Pages/MCFC_OL_V6/Pages/Signature"));
const MCFCOLV6_CreditAnalysis = React.lazy(() => import("./Components/Pages/MCFC_OL_V6/Pages/CreditAnalysis"));
const MCFCOLV6_Lenders = React.lazy(() => import("./Components/Pages/MCFC_OL_V6/Pages/Lenders"));
const MCFCOLV6_IDUpload = React.lazy(() => import("./Components/Pages/MCFC_OL_V6/Pages/IdUpload"));
const MCFCOLV6_Success = React.lazy(() => import("./Components/Pages/MCFC_OL_V6/Pages/Success"));
const MCFC_PrivacyPolicy = React.lazy(
  () => import("./Components/Pages/PrivacyPolicy_mcfc"),
);
const MCFC_OurFee = React.lazy(() => import("./Components/Pages/OurFee_mcfc"));
const LUFPDFVA2Signature = React.lazy(() => import("./Components/Pages/LUFP_DF_VA2/LUFPDFVA2Signature"));
const VerifyDetails = React.lazy(() => import("./Components/Pages/VerifyDetails/VerifyDetails"));
const KountPing = React.lazy(() => import("./Components/Pages/KountCheck/KountPing"));
const FollowupKountPing = React.lazy(() => import("./Components/Pages/Followup/FollowupKountPing"));
const FollowupMultiBureauCreditAnalysis = React.lazy(() => import("./Components/Pages/Followup/FollowupMultiBureauCreditAnalysis"));
const LUFPOtp = React.lazy(() => import("./Components/Pages/Otp/OtpV1"));
const MultiBureauCreditAnalysis = React.lazy(() => import("./Components/Pages/CreditAnalysis/MultiBureauCreditAnalysis"));
// const LUFPCreditAnalysisExperian = React.lazy(() => import("./Components/Pages/CreditAnalysis/CreditAnalysisExperian"));
const MultiCreditCheckEdit = React.lazy(() => import("./Components/Pages/EditPage/MultiCreditCheckEdit"));
const App = () => {
  const [visitorParameters] = useState({ visitor_parameters: [], data: [] });
  const [redirectUrl] = useState({ redirectUrl: '' });
  const domain = window.location.hostname;

  const unfair = domain.includes('unfairfinance.co.uk') || domain.includes('localhost');
  const everydomainexceptunfair = !domain.includes('unfairfinance.co.uk') || domain.includes('localhost');
  // console.log(domain);

  // useEffect(() => {
  //   document.title = EnvConstants.AppTitle;
  // }, []);
  return (
    <>
      <HelmetBasedOnDomain />
      <VisitorParamsProvider value={{ visitorParameters }}>
        <RedirectProvider value={{ redirectUrl }}>
          <BrowserRouter>
            <Suspense
              fallback={<div style={{ color: "#FFFFFF" }}>Loading...</div>}
            >
              <Route exact path="/" component={HomePage} />
              <Route exact path="/oa" component={HomePage} />
              <Route
                exact
                path="/lufp-v1-personal-details"
                component={LufpV1PersonalDetails}
              />
              <Route
                exact
                path="/lufp-v1-signature"
                component={LufpV1Signature}
              />
              <Route
                exact
                path="/lufp-v1-idupload"
                component={LufpV1IdUpload}
              />
              {/* <Route exact path="/lufp-v1-car-registration" component={LufpV1CarRegistration} /> */}
              <Route exact path="/lufp-v1-lenders" component={LufpV1Lenders} />
              <Route exact path={["/fbpixel"]} component={FbPixel} />
              <Route exact path={["/oa/fbpixel"]} component={FbPixel} />
              <Route
                exact
                path="/lufp-v1-Thankyou"
                component={LufpV1Thankyou}
              />
              <Route
                exact
                path="/thankyou-v2"
                component={ThankyouV2}
              />

              <Route
                exact
                path="/lufp-v1-credit-analysis"
                component={LufpV1CreditAnalysis}
              />
              <Route exact path="/loader" component={Loader} />
              <Route
                exact
                path={["/google", "/testing"]}
                component={AdtopiaLoadDynamic}
              />
              <Route
                exact
                path={["/:doc/:docType/:filename"]}
                component={EnvDocView}
              />
              <Route
                exact
                path="/lufp-v2-personal-details"
                component={LUFPV1BPersonalDetails}
              />
              <Route
                exact
                path="/lufp-v2-signature"
                component={LUFPV1BSignature}
              />
              <Route
                exact
                path="/lufp-v3-signature"
                component={LUFPV5BSignature}
              />
              <Route
                exact
                path="/lufp-v4-signature"
                component={LUFP_V5N1_1Signature}
              />
              <Route
                exact
                path="/lufp-v5-signature"
                component={LUFP_V5N1_1BSignature}
              />
              <Route
                exact
                path="/lufp-v6-signature"
                component={LUFP_V5N1_1ASignature}
              />
              <Route
                exact
                path="/lufp-v7-signature"
                component={LUFP_V5N1_1CSignature}
              />
              <Route
                exact
                path="/lufp-v8-signature"
                component={LUFP_V5N1_1B2Signature}
              />
              <Route
                exact
                path="/lufp-v10-signature"
                component={LUFP_V5N1_2ASignature}
              />
              <Route
                exact
                path="/lufp-v9-signature"
                component={LUFP_V7ASignature}
              />
              <Route
                exact
                path="/lufp-v11-signature"
                component={LUFPV9ASignature}
              />
              <Route
                exact
                path="/lufp-v2-credit-analysis"
                component={LUFPV1BCreditAnalysis}
              />
              <Route exact path={"/followup"} component={FollowUp} />
              {/* <Route exact path={"/followup"} component={NotFound} /> */}
              <Route
                exact
                path="/followup-signature"
                component={FollowupSignature}
              />
              <Route
                exact
                path="/followup-idupload"
                component={FollowupIdUplod}
              />
              <Route
                exact
                path="/followup-lenders"
                component={FollowupLenders}
              />
              {/* <Route exact path="/followup-car-registration" component={FollowupCarRegistration} /> */}
              <Route
                exact
                path="/followup-credit-analysis"
                component={FollowupCreditAnalysis}
              />
              <Route exact path="/followup-loader" component={FollowupLoader} />

              {/* HSL Followup Routes*/}
              <Route exact path={"/hsl-followup"} component={HslFollowUp} />
              <Route
                exact
                path="/hsl-followup-signature"
                component={HslFollowupSignature}
              />
              <Route
                exact
                path="/hsl-followup-idupload"
                component={HslFollowupIdUpload}
              />
              <Route
                exact
                path="/hsl-followup-lenders"
                component={HslFollwupLenders}
              />
              {/* <Route exact path="/hsl-followup-car-registration" component={HslFollowupCarRegistration} /> */}
              <Route
                exact
                path="/hsl-followup-credit-analysis"
                component={HslFollowupCreditAnalysis}
              />
              <Route
                exact
                path="/hsl-followup-loader"
                component={HslFollowupLoader}
              />
              <Route
                exact
                path="/hsl-followup-questionnaire-section"
                component={HslFollwupQuestionnaireSection}
              />

              {/* End HSL Followup Routes*/}

              {/* <Route exact path="/free_claims_checker/ADV_LUFP_1" component={ADV_LUFP_1} /> */}
              <Route
                exact
                path="/free_claims_checker/ADV_LUFP_1"
                component={NotFound}
              />
              {/* <Route exact path="/free_claims_checker/ADV_LUFP_2" component={ADV_LUFP_2} /> */}
              <Route
                exact
                path="/free_claims_checker/ADV_LUFP_2"
                component={NotFound}
              />
              <Route exact path="/lufp-v8-lenders" component={LUFPV8ALenders} />
              <Route
                exact
                path="/lufp-v8-credit-analysis"
                component={LUFPV8ACreditAnalysis}
              />

              {RoutingConfig.map((cfg) => renderRoute(cfg))}

              <Route
                exact
                path="/hidden-pcp-refunds/ADV_1"
                component={ADV_PCP_V1}
              />

              <Route
                exact
                path="/lufp-v1b1-personal-details"
                component={LUFPV1B1PersonalDetails}
              />
              <Route
                exact
                path="/lufp-v1b1-signature"
                component={LUFPV1B1Signature}
              />
              <Route
                exact
                path="/lufp-v1b1-credit-analysis"
                component={LUFPV1B1CreditAnalysis}
              />
              <Route
                exact
                path="/lufp-v1c-lenders"
                component={LufpV1CLenders}
              />
              <Route
                exact
                path="/lufp-v1c-creditcheck-lenders"
                component={LufpV1cCreditcheckLenders}
              />
              <Route exact path="/edit-details" component={EditDetails} />
              <Route
                exact
                path="/edit-credit-check"
                component={CreditCheckEdit}
              />
              <Route
                exact
                path="/followup-edit-details"
                component={FollowupEditDetails}
              />
              <Route
                exact
                path="/followup-edit-credit-check"
                component={FollowupCreditCheckEdit}
              />
              <Route
                exact
                path="/followup-multi-credit-check-edit"
                component={FollowupMultiCreditCheckEdit}
              />

              <Route exact path="/loaderV2" component={LoaderSavvy} />
              <Route
                exact
                path="/scheduled-maintenance"
                component={scheduledMaintenance}
              />
              <Route exact path="/hsl-load" component={HSLLoad} />
              <Route
                exact
                path="/questionnaire-section"
                component={QuestionnaireSection}
              />
              <Route
                exact
                path="/followup-questionnaire-section"
                component={FollwupQuestionnaireSection}
              />

              <Route
                exact
                path="/lead-summary/dashboard"
                component={Dashboard}
              />
              <Route
                exact
                path="/cancellation-form"
                component={CancellationForm}
              />
              <Route
                exact
                path="/oa/cancellation-form"
                component={CancellationForm}
              />
              <Route exact path="/hsl/dashboard" component={DashboardHSL} />
              <Route
                exact
                path="/lead-summary/dashboard/rs"
                component={DashboardRS}
              />
              <Route
                exact
                path="/hsl/dashboard/rs"
                component={DashboardHSLRS}
              />
              <Route
                exact
                path="/lufp-v3-personal-details"
                component={LUFPV8APersonalDetails}
              />
              <Route
                exact
                path="/lufp-v4-personal-details"
                component={LUFPV8BPersonalDetails}
              />
              <Route
                exact
                path="/lufp-v5-personal-details"
                component={LUFPV9PersonalDetails}
              />
              {/* LUFP_V10 */}
              <Route
                exact
                path="/lufp-v10-personal-details"
                component={LufpV10PersonalDetails}
              />
              <Route
                exact
                path="/signature_v10"
                component={LUFPV10Signature}
              />
              <Route
                exact
                path="/lufp-v10-credit-analysis"
                component={LufpV10CreditAnalysis}
              />
              <Route
                exact
                path="/lufp-v10-lenders"
                component={LUFPV10Lenders}
              />
              <Route
                exact
                path="/lufp-v10-idupload"
                component={LufpV10IdUpload}
              />
              <Route
                exact
                path="/lufp-v10-success"
                component={LufpV10Success}
              />
              <Route
                exact
                path="/edit-credit-check-v10"
                component={CreditCheckEditV10}
              />
              {/* LUFP_V10 */}
              <Route exact path="/address-verification" component={AddressVerification} />
              <Route exact path="/aml-check" component={AMLCheck} />
              <Route exact path="/credit-analysis-checkboard" component={CreditAnalysisCB} />
              <Route exact path="/cb-edit-details" component={CBEditDetails} />
              <Route exact path="/otp-verification" component={Otp} />
              <Route exact path="/cb-lenders" component={CBLenders} />

              <Route exact path="/followup-address-verification" component={FollowupAddressVerification} />
              <Route exact path="/followup-aml-check" component={FollowupAMLCheck} />
              <Route exact path="/followup-credit-analysis-cb" component={FollowupCreditAnalysisCB} />
              <Route exact path="/followup-otp" component={FollowupOtp} />
              <Route exact path="/followup-otp-v1" component={FollowupOtpV1} />
              <Route exact path="/followup-cb-lenders" component={FollowupCBLenders} />
              <Route exact path="/followup-cb-edit-details" component={FollowupCBEditDetails} />
              <Route exact path="/followup-kount-check" component={FollowupKountPing} />
              <Route exact path="/followup-multi-bureau-credit-analysis" component={FollowupMultiBureauCreditAnalysis} />
              {/* <Route exact path="/oa/lufp-rj-v1-personal-details" component={LUFPRJV1PersonalDetails} /> */}
              <Route exact path="/oa/rj-signature" component={RjSignature} />
              <Route exact path="/oa/rj-credit-analysis" component={RjV1CreditAnalysis} />
              <Route exact path="/oa/rj-lenders" component={RjV1Lenders} />
              <Route exact path="/oa/rj-id-upload" component={RjV1IdUpload} />
              <Route exact path="/oa/rj-success" component={RjV1Success} />
              <Route exact path="/oa/edit-details" component={RjEditDetails} />
              <Route exact path="/oa/edit-credit-check" component={RjCreditCheckEdit}/>
              <Route exact path="/terms" component={Terms} />
              <Route exact path={["/privacy-policy","/oa/privacy-policy"]} component={PrivacyPolicy} />
              <Route exact path="/mcfc-loader" component={Loader_MCFC_V5}/>
              <Route exact path="/mcfc-lenders" component={Lenders_MCFC_V5}/>
              <Route exact path="/mcfc-id-upload" component={Idupload_MCFC_V5}/>
              <Route exact path="/mcfc-success" component={Success_MCFC_V5}/>
              <Route exact path="/unsubscribe" component={Unsubscribe}/>
              <Route exact path="/mcfc-credit-check-edit" component={CreditCheckEdit_MCFC_V5}/>
              <Route exact path="/mcfc-edit-details" component={EditPage_MCFC_V5}/>
              <Route exact path="/mcfc-ol-personal-details" component={MCFCOLV6_PersonalDetails} />
              <Route exact path="/mcfc-ol-signature" component={MCFCOLV6_Signature} />
              <Route exact path="/mcfc-ol-credit-analysis" component={MCFCOLV6_CreditAnalysis} />
              <Route exact path="/mcfc-ol-lenders" component={MCFCOLV6_Lenders} />
              <Route exact path="/mcfc-ol-id-upload" component={MCFCOLV6_IDUpload} />
              <Route exact path="/mcfc-ol-success" component={MCFCOLV6_Success} />
              <Route exact path="/mcfc-privacy-policy" component={MCFC_PrivacyPolicy} />
              <Route exact path="/mcfc-our-fee" component={MCFC_OurFee} />
              <Route
                exact
                path="/lufp-df-va2signature"
                component={LUFPDFVA2Signature}
              />
              <Route exact path="/verify-details" component={VerifyDetails} />
              <Route
                exact
                path="/lufp-kount-check"
                component={KountPing}
              />
              <Route 
                exact 
                path="/lufp-otp"
                component={LUFPOtp}/>
              <Route 
                exact 
                path="/lufp-multi-bureau-credit-analysis"
                component={MultiBureauCreditAnalysis}/>
              <Route 
                exact 
                path="/lufp-multi-credit-check-edit"
                component={MultiCreditCheckEdit}/>
              {/* <Route
                exact
                path="/lufp-credit-analysis-ex"
                component={LUFPCreditAnalysisExperian}/> */}
            </Suspense>

            {/*<Route exact path={"/proceed-open-banking"} component={OpenBankingProceed} />
              <Route exact path={["/:enviroment/:project_id/pdf/:doc_type/:filename"]} component={PdfView}/>
              */}
          </BrowserRouter>
        </RedirectProvider>
      </VisitorParamsProvider>
    </>
  );
};

export default App;
